module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 16
// module chunks = 0